(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  // Keeps the mobile dots in step with the swipe. Inert on desktop,
  // where the grid is not a scroll container and the dots are hidden.
  class IwtCarousel {
    constructor(root) {
      this.track = root.querySelector('.image-with-text__grid');
      this.dots = Array.from(root.querySelectorAll('[data-iwt-dots] .iwt__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.from(this.track.children);
      this.ticking = false;

      this.track.addEventListener('scroll', () => this.request(), { passive: true });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[i];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      this.paint();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.paint();
        this.ticking = false;
      });
    }

    paint() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let nearest = 0;
      let best = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (d < best) {
          best = d;
          nearest = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === nearest));
    }
  }

  const initIwtCarousels = () => {
    document.querySelectorAll('[data-iwt-carousel]').forEach((root) => {
      if (root.dataset.iwtReady) return;
      root.dataset.iwtReady = 'true';
      new IwtCarousel(root);
    });
  };

  document.addEventListener('DOMContentLoaded', initIwtCarousels);
  document.addEventListener('shopify:section:load', initIwtCarousels);
  initIwtCarousels();


  // Fills one or more text viewports to the media's height, then turns
  // the page. With two viewports it pours into the left column, then the
  // right, before paging — which is what lets text run around a video
  // sitting between them.
  class AutoPagedText extends HTMLElement {
    connectedCallback() {
      this.viewports = Array.from(this.querySelectorAll('[data-vwt-viewport]'));
      this.controls = this.querySelector('[data-vwt-controls]');
      this.numList = this.querySelector('[data-vwt-nums]');
      this.heading = this.querySelector('[data-vwt-heading]');
      if (!this.viewports.length) return;

      // Source is an explicit hidden node when there are several
      // viewports, otherwise the first viewport's own children.
      const src = this.querySelector('[data-vwt-source]');
      this.source = Array.from((src || this.viewports[0]).children).map((n) => n.cloneNode(true));
      if (!this.source.length) return;

      // A missing data-media used to mean querySelector(null), which
      // throws and aborted the whole build — that is why the text
      // vanished in the text/video/text layout.
      const mediaSel = this.getAttribute('data-media');
      this.media = mediaSel ? document.querySelector(mediaSel) : null;
      if (!this.media) {
        this.media =
          this.querySelector('[data-vwt-media]') ||
          (this.closest('[data-vwt-grid]') || document).querySelector('[data-vwt-media]');
      }
      this.index = 0;

      const prev = this.querySelector('[data-vwt-prev]');
      const next = this.querySelector('[data-vwt-next]');
      if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
      if (next) next.addEventListener('click', () => this.show(this.index + 1));

      this.schedule();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.schedule());
        if (this.media) this.observer.observe(this.media);
        this.observer.observe(this);
      } else {
        this.onResize = () => this.schedule();
        window.addEventListener('resize', this.onResize);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.build(), 120);
    }

    // Show the original text unpaged. Used whenever paging cannot run
    // or produces nothing, so a failure degrades to plain text rather
    // than an empty column.
    restore() {
      const src = this.querySelector('[data-vwt-source]');
      if (src) {
        src.hidden = false;
        this.viewports.forEach((vp, i) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = i > 0;
        });
      } else if (this.viewports[0]) {
        this.viewports[0].style.height = '';
        if (!this.viewports[0].children.length) {
          this.source.forEach((n) => this.viewports[0].appendChild(n.cloneNode(true)));
        }
      }
      this.pages = null;
      if (this.controls) this.controls.hidden = true;
    }

    outerHeight(el) {
      if (!el || el.hidden) return 0;
      const cs = window.getComputedStyle(el);
      return el.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0);
    }

    build() {
      if (this.building) return;
      this.building = true;

      try {
        // Some sections page on mobile only. Above the breakpoint the
        // text is simply shown in full.
        if (this.dataset.mobileOnly === 'true' && window.matchMedia('(min-width: 750px)').matches) {
          this.restore();
          this.building = false;
          return;
        }

        const min = parseInt(this.dataset.minHeight || '320', 10);
        if (!this.viewports[0].getBoundingClientRect().width) {
          this.building = false;
          return;
        }
        if (!this.source.length) {
          this.restore();
          this.building = false;
          return;
        }

        let mediaH = this.media ? this.media.getBoundingClientRect().height : 0;
        if (!mediaH) mediaH = min;
        mediaH = Math.max(mediaH, min);

        if (this.controls) this.controls.hidden = false;

        let chrome = this.outerHeight(this.heading) + this.outerHeight(this.controls);
        this.querySelectorAll('[data-vwt-chrome]').forEach((el) => {
          if (el !== this.controls && el !== this.heading) chrome += this.outerHeight(el);
        });
        const limit = Math.max(mediaH - chrome, 160);

        const wide = window.matchMedia('(min-width: 750px)').matches;
        const colGap = parseInt(this.dataset.columnGap || '40', 10);
        const fillPages = this.dataset.fill !== 'false';
        // Only viewports that are actually on screen take part. That is
        // mobile without a second code path.
        const vps = this.viewports.filter((vp) => vp.offsetParent !== null || vp.getClientRects().length);
        const active = vps.length ? vps : this.viewports;
        const slots = active.length;

        const pages = [];
        let current = [];
        let slot = 0;
        let probe = null;

        const makeProbe = () => {
          if (probe) probe.remove();
          const vp = active[slot];
          const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
          probe = document.createElement('div');
          probe.className = this.dataset.pageClass || 'vwt__page';
          probe.dataset.cols = cols;
          probe.setAttribute(
            'style',
            'position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:' +
              vp.getBoundingClientRect().width + 'px;' +
              (cols > 1
                ? 'height:' + limit + 'px;column-count:' + cols + ';column-gap:' + colGap + 'px;column-fill:auto;'
                : 'height:auto;')
          );
          vp.appendChild(probe);
        };

        const fits = () =>
          parseInt(probe.dataset.cols, 10) > 1
            ? probe.scrollWidth <= probe.clientWidth + 1
            : probe.scrollHeight <= limit;

        const closeSlot = () => {
          if (!pages.length || pages[pages.length - 1].length === slots) pages.push([]);
          pages[pages.length - 1].push(current);
          current = [];
          slot = (slot + 1) % slots;
          makeProbe();
        };

        const addWhole = (node) => {
          const clone = node.cloneNode(true);
          probe.appendChild(clone);
          if (fits()) {
            current.push(node.cloneNode(true));
            return true;
          }
          probe.removeChild(clone);
          return false;
        };

        const pourInto = (node) => {
          const words = (node.textContent || '').split(/\s+/).filter(Boolean);
          if (!words.length) return;
          let piece = node.cloneNode(false);
          probe.appendChild(piece);
          let buffer = [];

          for (let i = 0; i < words.length; i++) {
            buffer.push(words[i]);
            piece.textContent = buffer.join(' ');
            if (fits()) continue;
            if (buffer.length === 1 && !current.length) continue;

            if (buffer.length > 1) {
              buffer.pop();
              piece.textContent = buffer.join(' ');
              i -= 1;
            }
            current.push(piece.cloneNode(true));
            closeSlot();
            piece = node.cloneNode(false);
            piece.textContent = '';
            probe.appendChild(piece);
            buffer = [];
          }
          if (buffer.length) current.push(piece.cloneNode(true));
        };

        makeProbe();

        this.source.forEach((node) => {
          if (addWhole(node)) return;
          if (fillPages) {
            pourInto(node);
            return;
          }
          if (current.length) closeSlot();
          if (!addWhole(node)) pourInto(node);
        });
        if (current.length) closeSlot();
        if (probe) probe.remove();

        const real = pages.filter((page) =>
          page.some((sl) => sl.some((n) => (n.textContent || '').trim().length))
        );
        if (!real.length) {
          this.restore();
          this.building = false;
          return;
        }

        const srcEl = this.querySelector('[data-vwt-source]');
        if (srcEl) srcEl.hidden = true;

        this.viewports.forEach((vp) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = false;
        });
        const single = real.length === 1 && this.dataset.vcenter === 'true';
        active.forEach((vp) => {
          // Natural height when everything fits on one page and centring
          // is on, so the whole block can sit in the middle.
          vp.style.height = single ? '' : limit + 'px';
        });

        this.pages = real.map((page) =>
          active.map((vp, i) => {
            const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
            const el = document.createElement('div');
            el.className = 'vwt__page';
            if (cols > 1) {
              el.style.columnCount = cols;
              el.style.columnGap = colGap + 'px';
              el.style.columnFill = 'auto';
              el.style.height = limit + 'px';
            }
            (page[i] || []).forEach((n) => el.appendChild(n));
            vp.appendChild(el);
            return el;
          })
        );

        if (this.controls) this.controls.hidden = this.pages.length < 2;

        if (this.numList) {
          const useNumbers = (this.dataset.pager || 'arrows-numbers') !== 'arrows';
          this.numList.innerHTML = '';
          this.numList.hidden = !useNumbers;
          if (useNumbers) {
            this.pages.forEach((_, i) => {
              const li = document.createElement('li');
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'vwt__num';
              btn.textContent = String(i + 1);
              btn.setAttribute('aria-label', 'Page ' + (i + 1));
              btn.addEventListener('click', () => this.show(i));
              li.appendChild(btn);
              this.numList.appendChild(li);
            });
          }
        }

        this.show(Math.min(this.index, this.pages.length - 1));
      } catch (e) {
        console.error('[video] paging failed, showing full text', e);
        this.restore();
      }

      this.building = false;
    }

    show(target) {
      if (!this.pages || !this.pages.length) return;
      const total = this.pages.length;
      this.index = ((target % total) + total) % total;
      this.pages.forEach((page, i) => page.forEach((el) => (el.hidden = i !== this.index)));

      if (this.numList) {
        Array.from(this.numList.querySelectorAll('.vwt__num')).forEach((btn, i) => {
          btn.classList.toggle('is-active', i === this.index);
          btn.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
      }
    }
  }

  // Two sections can both ship this engine. Defining the same element
  // twice throws, so only the first one on the page registers it.
  if (!customElements.get('auto-paged-text')) {
    customElements.define('auto-paged-text', AutoPagedText);
  }

  // Mobile media carousel: keeps the dots in step with the swipe. Does
  // nothing on desktop, where the track is display:contents and the
  // dots are hidden.
  class VwtCarousel {
    constructor(wrap) {
      this.track = wrap.querySelector('[data-vwt-track]');
      this.dots = Array.from(wrap.querySelectorAll('[data-vwt-dots] .vwt__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.from(this.track.children);
      this.ticking = false;

      this.track.addEventListener('scroll', () => this.request(), { passive: true });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[i];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      this.paint();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.paint();
        this.ticking = false;
      });
    }

    paint() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let nearest = 0;
      let best = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (d < best) {
          best = d;
          nearest = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === nearest));
    }
  }

  const initVwtCarousels = () => {
    document.querySelectorAll('[data-vwt-carousel]').forEach((wrap) => {
      if (wrap.dataset.vwtReady) return;
      wrap.dataset.vwtReady = 'true';
      new VwtCarousel(wrap);
    });
  };

  document.addEventListener('DOMContentLoaded', initVwtCarousels);
  document.addEventListener('shopify:section:load', initVwtCarousels);
  initVwtCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  // Fades the neighbouring carousel slides up as they approach the
  // active position. Opacity only — no layout is read or written.
  class McFade {
    constructor(list) {
      this.list = list;
      this.dim = Math.max(0, Math.min(100, parseInt(list.dataset.mcDim || '20', 10))) / 100;
      this.items = Array.from(list.children);
      if (this.items.length < 2) return;

      this.ticking = false;
      this.onScroll = () => this.request();
      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      // The first paint can land before the track has been laid out,
      // when widths still read as zero and the distance maths is
      // meaningless. Repaint once the page and its images are in, and
      // whenever the track resizes.
      window.addEventListener('load', this.onScroll);

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.request());
        this.observer.observe(this.list);
      }

      requestAnimationFrame(() => requestAnimationFrame(() => this.paint()));
      this.paint();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.paint();
        this.ticking = false;
      });
    }

    paint() {
      // Only while Dawn is actually running this as a slider.
      if (!this.list.classList.contains('slider')) {
        this.items.forEach((i) => (i.style.opacity = ''));
        return;
      }

      const span = this.items[0].offsetWidth || this.list.clientWidth;

      // Nothing measurable yet. Leaving the CSS defaults in place keeps
      // the first slide lit rather than writing a wrong opacity.
      if (!span) return;

      // Measured against the track's own scroll position rather than
      // screen coordinates. Dawn's peek layout puts padding on the
      // track, so the first slide does not sit flush at the left edge —
      // anchoring on that edge left it fractionally "away" and so
      // slightly dimmed on first load.
      const padLeft = parseFloat(window.getComputedStyle(this.list).paddingLeft) || 0;
      const activeLeft = this.list.scrollLeft + padLeft;

      this.items.forEach((item) => {
        const distance = Math.abs(item.offsetLeft - activeLeft);
        const t = Math.max(0, 1 - distance / span);
        item.style.opacity = String(this.dim + (1 - this.dim) * t);
      });
    }
  }

  const initMcFade = () => {
    document.querySelectorAll('[data-mc-fade]').forEach((list) => {
      if (list.dataset.mcReady) return;
      list.dataset.mcReady = 'true';
      new McFade(list);
    });
  };

  document.addEventListener('DOMContentLoaded', initMcFade);
  document.addEventListener('shopify:section:load', initMcFade);
  initMcFade();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    


  // Fills one or more text viewports to the media's height, then turns
  // the page. With two viewports it pours into the left column, then the
  // right, before paging — which is what lets text run around a video
  // sitting between them.
  class AutoPagedText extends HTMLElement {
    connectedCallback() {
      this.viewports = Array.from(this.querySelectorAll('[data-vwt-viewport]'));
      this.controls = this.querySelector('[data-vwt-controls]');
      this.numList = this.querySelector('[data-vwt-nums]');
      this.heading = this.querySelector('[data-vwt-heading]');
      if (!this.viewports.length) return;

      // Source is an explicit hidden node when there are several
      // viewports, otherwise the first viewport's own children.
      const src = this.querySelector('[data-vwt-source]');
      this.source = Array.from((src || this.viewports[0]).children).map((n) => n.cloneNode(true));
      if (!this.source.length) return;

      // A missing data-media used to mean querySelector(null), which
      // throws and aborted the whole build — that is why the text
      // vanished in the text/video/text layout.
      const mediaSel = this.getAttribute('data-media');
      this.media = mediaSel ? document.querySelector(mediaSel) : null;
      if (!this.media) {
        this.media =
          this.querySelector('[data-vwt-media]') ||
          (this.closest('[data-vwt-grid]') || document).querySelector('[data-vwt-media]');
      }
      this.index = 0;

      const prev = this.querySelector('[data-vwt-prev]');
      const next = this.querySelector('[data-vwt-next]');
      if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
      if (next) next.addEventListener('click', () => this.show(this.index + 1));

      this.schedule();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.schedule());
        if (this.media) this.observer.observe(this.media);
        this.observer.observe(this);
      } else {
        this.onResize = () => this.schedule();
        window.addEventListener('resize', this.onResize);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.build(), 120);
    }

    // Show the original text unpaged. Used whenever paging cannot run
    // or produces nothing, so a failure degrades to plain text rather
    // than an empty column.
    restore() {
      const src = this.querySelector('[data-vwt-source]');
      if (src) {
        src.hidden = false;
        this.viewports.forEach((vp, i) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = i > 0;
        });
      } else if (this.viewports[0]) {
        this.viewports[0].style.height = '';
        if (!this.viewports[0].children.length) {
          this.source.forEach((n) => this.viewports[0].appendChild(n.cloneNode(true)));
        }
      }
      this.pages = null;
      if (this.controls) this.controls.hidden = true;
    }

    outerHeight(el) {
      if (!el || el.hidden) return 0;
      const cs = window.getComputedStyle(el);
      return el.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0);
    }

    build() {
      if (this.building) return;
      this.building = true;

      try {
        // Some sections page on mobile only. Above the breakpoint the
        // text is simply shown in full.
        if (this.dataset.mobileOnly === 'true' && window.matchMedia('(min-width: 750px)').matches) {
          this.restore();
          this.building = false;
          return;
        }

        const min = parseInt(this.dataset.minHeight || '320', 10);
        if (!this.viewports[0].getBoundingClientRect().width) {
          this.building = false;
          return;
        }
        if (!this.source.length) {
          this.restore();
          this.building = false;
          return;
        }

        let mediaH = this.media ? this.media.getBoundingClientRect().height : 0;
        if (!mediaH) mediaH = min;
        mediaH = Math.max(mediaH, min);

        if (this.controls) this.controls.hidden = false;

        let chrome = this.outerHeight(this.heading) + this.outerHeight(this.controls);
        this.querySelectorAll('[data-vwt-chrome]').forEach((el) => {
          if (el !== this.controls && el !== this.heading) chrome += this.outerHeight(el);
        });
        const limit = Math.max(mediaH - chrome, 160);

        const wide = window.matchMedia('(min-width: 750px)').matches;
        const colGap = parseInt(this.dataset.columnGap || '40', 10);
        const fillPages = this.dataset.fill !== 'false';
        // Only viewports that are actually on screen take part. That is
        // mobile without a second code path.
        const vps = this.viewports.filter((vp) => vp.offsetParent !== null || vp.getClientRects().length);
        const active = vps.length ? vps : this.viewports;
        const slots = active.length;

        const pages = [];
        let current = [];
        let slot = 0;
        let probe = null;

        const makeProbe = () => {
          if (probe) probe.remove();
          const vp = active[slot];
          const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
          probe = document.createElement('div');
          probe.className = this.dataset.pageClass || 'vwt__page';
          probe.dataset.cols = cols;
          probe.setAttribute(
            'style',
            'position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:' +
              vp.getBoundingClientRect().width + 'px;' +
              (cols > 1
                ? 'height:' + limit + 'px;column-count:' + cols + ';column-gap:' + colGap + 'px;column-fill:auto;'
                : 'height:auto;')
          );
          vp.appendChild(probe);
        };

        const fits = () =>
          parseInt(probe.dataset.cols, 10) > 1
            ? probe.scrollWidth <= probe.clientWidth + 1
            : probe.scrollHeight <= limit;

        const closeSlot = () => {
          if (!pages.length || pages[pages.length - 1].length === slots) pages.push([]);
          pages[pages.length - 1].push(current);
          current = [];
          slot = (slot + 1) % slots;
          makeProbe();
        };

        const addWhole = (node) => {
          const clone = node.cloneNode(true);
          probe.appendChild(clone);
          if (fits()) {
            current.push(node.cloneNode(true));
            return true;
          }
          probe.removeChild(clone);
          return false;
        };

        const pourInto = (node) => {
          const words = (node.textContent || '').split(/\s+/).filter(Boolean);
          if (!words.length) return;
          let piece = node.cloneNode(false);
          probe.appendChild(piece);
          let buffer = [];

          for (let i = 0; i < words.length; i++) {
            buffer.push(words[i]);
            piece.textContent = buffer.join(' ');
            if (fits()) continue;
            if (buffer.length === 1 && !current.length) continue;

            if (buffer.length > 1) {
              buffer.pop();
              piece.textContent = buffer.join(' ');
              i -= 1;
            }
            current.push(piece.cloneNode(true));
            closeSlot();
            piece = node.cloneNode(false);
            piece.textContent = '';
            probe.appendChild(piece);
            buffer = [];
          }
          if (buffer.length) current.push(piece.cloneNode(true));
        };

        makeProbe();

        this.source.forEach((node) => {
          if (addWhole(node)) return;
          if (fillPages) {
            pourInto(node);
            return;
          }
          if (current.length) closeSlot();
          if (!addWhole(node)) pourInto(node);
        });
        if (current.length) closeSlot();
        if (probe) probe.remove();

        const real = pages.filter((page) =>
          page.some((sl) => sl.some((n) => (n.textContent || '').trim().length))
        );
        if (!real.length) {
          this.restore();
          this.building = false;
          return;
        }

        const srcEl = this.querySelector('[data-vwt-source]');
        if (srcEl) srcEl.hidden = true;

        this.viewports.forEach((vp) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = false;
        });
        const single = real.length === 1 && this.dataset.vcenter === 'true';
        active.forEach((vp) => {
          // Natural height when everything fits on one page and centring
          // is on, so the whole block can sit in the middle.
          vp.style.height = single ? '' : limit + 'px';
        });

        this.pages = real.map((page) =>
          active.map((vp, i) => {
            const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
            const el = document.createElement('div');
            el.className = 'vwt__page';
            if (cols > 1) {
              el.style.columnCount = cols;
              el.style.columnGap = colGap + 'px';
              el.style.columnFill = 'auto';
              el.style.height = limit + 'px';
            }
            (page[i] || []).forEach((n) => el.appendChild(n));
            vp.appendChild(el);
            return el;
          })
        );

        if (this.controls) this.controls.hidden = this.pages.length < 2;

        if (this.numList) {
          const useNumbers = (this.dataset.pager || 'arrows-numbers') !== 'arrows';
          this.numList.innerHTML = '';
          this.numList.hidden = !useNumbers;
          if (useNumbers) {
            this.pages.forEach((_, i) => {
              const li = document.createElement('li');
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'vwt__num';
              btn.textContent = String(i + 1);
              btn.setAttribute('aria-label', 'Page ' + (i + 1));
              btn.addEventListener('click', () => this.show(i));
              li.appendChild(btn);
              this.numList.appendChild(li);
            });
          }
        }

        this.show(Math.min(this.index, this.pages.length - 1));
      } catch (e) {
        console.error('[video] paging failed, showing full text', e);
        this.restore();
      }

      this.building = false;
    }

    show(target) {
      if (!this.pages || !this.pages.length) return;
      const total = this.pages.length;
      this.index = ((target % total) + total) % total;
      this.pages.forEach((page, i) => page.forEach((el) => (el.hidden = i !== this.index)));

      if (this.numList) {
        Array.from(this.numList.querySelectorAll('.vwt__num')).forEach((btn, i) => {
          btn.classList.toggle('is-active', i === this.index);
          btn.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
      }
    }
  }

  // Two sections can both ship this engine. Defining the same element
  // twice throws, so only the first one on the page registers it.
  if (!customElements.get('auto-paged-text')) {
    customElements.define('auto-paged-text', AutoPagedText);
  }

  // Mobile media carousel: keeps the dots in step with the swipe. Does
  // nothing on desktop, where the track is display:contents and the
  // dots are hidden.
  class VwtCarousel {
    constructor(wrap) {
      this.track = wrap.querySelector('[data-vwt-track]');
      this.dots = Array.from(wrap.querySelectorAll('[data-vwt-dots] .vwt__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.from(this.track.children);
      this.ticking = false;

      this.track.addEventListener('scroll', () => this.request(), { passive: true });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[i];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      this.paint();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.paint();
        this.ticking = false;
      });
    }

    paint() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let nearest = 0;
      let best = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (d < best) {
          best = d;
          nearest = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === nearest));
    }
  }

  const initVwtCarousels = () => {
    document.querySelectorAll('[data-vwt-carousel]').forEach((wrap) => {
      if (wrap.dataset.vwtReady) return;
      wrap.dataset.vwtReady = 'true';
      new VwtCarousel(wrap);
    });
  };

  document.addEventListener('DOMContentLoaded', initVwtCarousels);
  document.addEventListener('shopify:section:load', initVwtCarousels);
  initVwtCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    

  // Fills one or more text viewports to the media's height, then turns
  // the page. With two viewports it pours into the left column, then the
  // right, before paging — which is what lets text run around a video
  // sitting between them.
  class AutoPagedText extends HTMLElement {
    connectedCallback() {
      this.viewports = Array.from(this.querySelectorAll('[data-vwt-viewport]'));
      this.controls = this.querySelector('[data-vwt-controls]');
      this.numList = this.querySelector('[data-vwt-nums]');
      this.heading = this.querySelector('[data-vwt-heading]');
      if (!this.viewports.length) return;

      // Source is an explicit hidden node when there are several
      // viewports, otherwise the first viewport's own children.
      const src = this.querySelector('[data-vwt-source]');
      this.source = Array.from((src || this.viewports[0]).children).map((n) => n.cloneNode(true));
      if (!this.source.length) return;

      // A missing data-media used to mean querySelector(null), which
      // throws and aborted the whole build — that is why the text
      // vanished in the text/video/text layout.
      const mediaSel = this.getAttribute('data-media');
      this.media = mediaSel ? document.querySelector(mediaSel) : null;
      if (!this.media) {
        this.media =
          this.querySelector('[data-vwt-media]') ||
          (this.closest('[data-vwt-grid]') || document).querySelector('[data-vwt-media]');
      }
      this.index = 0;

      const prev = this.querySelector('[data-vwt-prev]');
      const next = this.querySelector('[data-vwt-next]');
      if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
      if (next) next.addEventListener('click', () => this.show(this.index + 1));

      this.schedule();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.schedule());
        if (this.media) this.observer.observe(this.media);
        this.observer.observe(this);
      } else {
        this.onResize = () => this.schedule();
        window.addEventListener('resize', this.onResize);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.build(), 120);
    }

    // Show the original text unpaged. Used whenever paging cannot run
    // or produces nothing, so a failure degrades to plain text rather
    // than an empty column.
    restore() {
      const src = this.querySelector('[data-vwt-source]');
      if (src) {
        src.hidden = false;
        this.viewports.forEach((vp, i) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = i > 0;
        });
      } else if (this.viewports[0]) {
        this.viewports[0].style.height = '';
        if (!this.viewports[0].children.length) {
          this.source.forEach((n) => this.viewports[0].appendChild(n.cloneNode(true)));
        }
      }
      this.pages = null;
      if (this.controls) this.controls.hidden = true;
    }

    outerHeight(el) {
      if (!el || el.hidden) return 0;
      const cs = window.getComputedStyle(el);
      return el.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0);
    }

    build() {
      if (this.building) return;
      this.building = true;

      try {
        const min = parseInt(this.dataset.minHeight || '320', 10);
        if (!this.viewports[0].getBoundingClientRect().width) {
          this.building = false;
          return;
        }
        if (!this.source.length) {
          this.restore();
          this.building = false;
          return;
        }

        let mediaH = this.media ? this.media.getBoundingClientRect().height : 0;
        if (!mediaH) mediaH = min;
        mediaH = Math.max(mediaH, min);

        if (this.controls) this.controls.hidden = false;

        let chrome = this.outerHeight(this.heading) + this.outerHeight(this.controls);
        this.querySelectorAll('[data-vwt-chrome]').forEach((el) => {
          if (el !== this.controls && el !== this.heading) chrome += this.outerHeight(el);
        });
        const limit = Math.max(mediaH - chrome, 160);

        const wide = window.matchMedia('(min-width: 750px)').matches;
        const colGap = parseInt(this.dataset.columnGap || '40', 10);
        const fillPages = this.dataset.fill !== 'false';
        // Only viewports that are actually on screen take part. That is
        // mobile without a second code path.
        const vps = this.viewports.filter((vp) => vp.offsetParent !== null || vp.getClientRects().length);
        const active = vps.length ? vps : this.viewports;
        const slots = active.length;

        const pages = [];
        let current = [];
        let slot = 0;
        let probe = null;

        const makeProbe = () => {
          if (probe) probe.remove();
          const vp = active[slot];
          const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
          probe = document.createElement('div');
          probe.className = this.dataset.pageClass || 'vwt__page';
          probe.dataset.cols = cols;
          probe.setAttribute(
            'style',
            'position:absolute;visibility:hidden;pointer-events:none;top:0;left:0;width:' +
              vp.getBoundingClientRect().width + 'px;' +
              (cols > 1
                ? 'height:' + limit + 'px;column-count:' + cols + ';column-gap:' + colGap + 'px;column-fill:auto;'
                : 'height:auto;')
          );
          vp.appendChild(probe);
        };

        const fits = () =>
          parseInt(probe.dataset.cols, 10) > 1
            ? probe.scrollWidth <= probe.clientWidth + 1
            : probe.scrollHeight <= limit;

        const closeSlot = () => {
          if (!pages.length || pages[pages.length - 1].length === slots) pages.push([]);
          pages[pages.length - 1].push(current);
          current = [];
          slot = (slot + 1) % slots;
          makeProbe();
        };

        const addWhole = (node) => {
          const clone = node.cloneNode(true);
          probe.appendChild(clone);
          if (fits()) {
            current.push(node.cloneNode(true));
            return true;
          }
          probe.removeChild(clone);
          return false;
        };

        const pourInto = (node) => {
          const words = (node.textContent || '').split(/\s+/).filter(Boolean);
          if (!words.length) return;
          let piece = node.cloneNode(false);
          probe.appendChild(piece);
          let buffer = [];

          for (let i = 0; i < words.length; i++) {
            buffer.push(words[i]);
            piece.textContent = buffer.join(' ');
            if (fits()) continue;
            if (buffer.length === 1 && !current.length) continue;

            if (buffer.length > 1) {
              buffer.pop();
              piece.textContent = buffer.join(' ');
              i -= 1;
            }
            current.push(piece.cloneNode(true));
            closeSlot();
            piece = node.cloneNode(false);
            piece.textContent = '';
            probe.appendChild(piece);
            buffer = [];
          }
          if (buffer.length) current.push(piece.cloneNode(true));
        };

        makeProbe();

        this.source.forEach((node) => {
          if (addWhole(node)) return;
          if (fillPages) {
            pourInto(node);
            return;
          }
          if (current.length) closeSlot();
          if (!addWhole(node)) pourInto(node);
        });
        if (current.length) closeSlot();
        if (probe) probe.remove();

        const real = pages.filter((page) =>
          page.some((sl) => sl.some((n) => (n.textContent || '').trim().length))
        );
        if (!real.length) {
          this.restore();
          this.building = false;
          return;
        }

        const srcEl = this.querySelector('[data-vwt-source]');
        if (srcEl) srcEl.hidden = true;

        this.viewports.forEach((vp) => {
          vp.innerHTML = '';
          vp.style.height = '';
          vp.hidden = false;
        });
        const single = real.length === 1 && this.dataset.vcenter === 'true';
        active.forEach((vp) => {
          // Natural height when everything fits on one page and centring
          // is on, so the whole block can sit in the middle.
          vp.style.height = single ? '' : limit + 'px';
        });

        this.pages = real.map((page) =>
          active.map((vp, i) => {
            const cols = wide ? Math.max(1, parseInt(vp.dataset.columns || '1', 10)) : 1;
            const el = document.createElement('div');
            el.className = 'vwt__page';
            if (cols > 1) {
              el.style.columnCount = cols;
              el.style.columnGap = colGap + 'px';
              el.style.columnFill = 'auto';
              el.style.height = limit + 'px';
            }
            (page[i] || []).forEach((n) => el.appendChild(n));
            vp.appendChild(el);
            return el;
          })
        );

        if (this.controls) this.controls.hidden = this.pages.length < 2;

        if (this.numList) {
          const useNumbers = (this.dataset.pager || 'arrows-numbers') !== 'arrows';
          this.numList.innerHTML = '';
          this.numList.hidden = !useNumbers;
          if (useNumbers) {
            this.pages.forEach((_, i) => {
              const li = document.createElement('li');
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'vwt__num';
              btn.textContent = String(i + 1);
              btn.setAttribute('aria-label', 'Page ' + (i + 1));
              btn.addEventListener('click', () => this.show(i));
              li.appendChild(btn);
              this.numList.appendChild(li);
            });
          }
        }

        this.show(Math.min(this.index, this.pages.length - 1));
      } catch (e) {
        console.error('[video] paging failed, showing full text', e);
        this.restore();
      }

      this.building = false;
    }

    show(target) {
      if (!this.pages || !this.pages.length) return;
      const total = this.pages.length;
      this.index = ((target % total) + total) % total;
      this.pages.forEach((page, i) => page.forEach((el) => (el.hidden = i !== this.index)));

      if (this.numList) {
        Array.from(this.numList.querySelectorAll('.vwt__num')).forEach((btn, i) => {
          btn.classList.toggle('is-active', i === this.index);
          btn.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
      }
    }
  }

  customElements.define('auto-paged-text', AutoPagedText);

  // Mobile media carousel: keeps the dots in step with the swipe. Does
  // nothing on desktop, where the track is display:contents and the
  // dots are hidden.
  class VwtCarousel {
    constructor(wrap) {
      this.track = wrap.querySelector('[data-vwt-track]');
      this.dots = Array.from(wrap.querySelectorAll('[data-vwt-dots] .vwt__dot'));
      if (!this.track || this.dots.length < 2) return;

      this.slides = Array.from(this.track.children);
      this.ticking = false;

      this.track.addEventListener('scroll', () => this.request(), { passive: true });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const slide = this.slides[i];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      this.paint();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.paint();
        this.ticking = false;
      });
    }

    paint() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let nearest = 0;
      let best = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - mid);
        if (d < best) {
          best = d;
          nearest = i;
        }
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === nearest));
    }
  }

  const initVwtCarousels = () => {
    document.querySelectorAll('[data-vwt-carousel]').forEach((wrap) => {
      if (wrap.dataset.vwtReady) return;
      wrap.dataset.vwtReady = 'true';
      new VwtCarousel(wrap);
    });
  };

  document.addEventListener('DOMContentLoaded', initVwtCarousels);
  document.addEventListener('shopify:section:load', initVwtCarousels);
  initVwtCarousels();

  } catch(e) { console.error(e); }
})();
})();
